/* /help: renders HELP_TOPICS and filters them as you type. The search box keeps ?q= in the URL so a
   filtered view can be shared; #topic-id links scroll to one topic. */
import { HELP_TOPICS, searchTopics } from "./help-topics.js";

var list = document.getElementById("topics");
var toc = document.getElementById("toc");
var q = document.getElementById("helpQ");
var countEl = document.getElementById("helpCount");
var COLORS = ["var(--t-customer)", "var(--t-job)", "var(--t-quote)", "var(--t-supplier)", "var(--t-invoice)", "var(--t-van)", "var(--t-meeting)"];

function esc(s){ return String(s).replace(/[&<>"']/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]; }); }

/* highlight query words in text nodes only (bodies are trusted HTML written in help-topics.js) */
function mark(root, words){
  if(!words.length) return;
  var re = new RegExp("(" + words.map(function(w){ return w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }).join("|") + ")", "ig");
  var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), nodes = [];
  while(walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach(function(node){
    if(!re.test(node.nodeValue)) return;
    re.lastIndex = 0;
    var span = document.createElement("span");
    span.innerHTML = esc(node.nodeValue).replace(re, "<mark>$1</mark>");
    node.parentNode.replaceChild(span, node);
  });
}

function render(){
  var query = q.value.trim();
  var words = query.toLowerCase().split(/\s+/).filter(function(w){ return w.length > 1; });
  var found = searchTopics(query);
  list.innerHTML = found.map(function(t){
    var i = HELP_TOPICS.indexOf(t);
    return '<article class="ic topic" id="' + esc(t.id) + '" style="--tc:' + COLORS[i % COLORS.length] + '" aria-labelledby="h-' + esc(t.id) + '">' +
      '<span class="ic-tab"><b>' + esc(t.code || "") + '</b> ' + esc(t.title) + '</span>' +
      '<div class="ic-head"><h2 id="h-' + esc(t.id) + '" style="font-size:22px">' + esc(t.title) + '</h2></div>' +
      '<div class="topic-body">' + t.body + '</div></article>';
  }).join("") || '<div class="empty-help"><b>No topics match “' + esc(query) + '”.</b><span>Try a shorter word, such as “remind” or “import”.</span></div>';
  if(words.length) Array.prototype.forEach.call(list.querySelectorAll(".topic"), function(el){ mark(el, words); });
  countEl.textContent = query ? (found.length === 1 ? "1 topic" : found.length + " topics") + " match “" + query + "”" : HELP_TOPICS.length + " topics";
  toc.innerHTML = found.map(function(t){ return '<a href="#' + esc(t.id) + '">' + esc(t.title) + '</a>'; }).join("");
}

var params = new URLSearchParams(location.search);
if(params.get("q")) q.value = params.get("q");
render();
var t0 = 0;
q.addEventListener("input", function(){
  render();
  clearTimeout(t0);
  t0 = setTimeout(function(){
    var u = new URL(location.href);
    if(q.value.trim()) u.searchParams.set("q", q.value.trim()); else u.searchParams.delete("q");
    u.hash = "";
    history.replaceState(null, "", u.pathname + u.search);
  }, 400);
});
q.addEventListener("keydown", function(e){
  if(e.key === "Escape" && q.value){ q.value = ""; render(); }
  if(e.key === "Enter"){ var first = list.querySelector(".topic"); if(first){ e.preventDefault(); first.scrollIntoView({block: "start"}); } }
});
document.addEventListener("keydown", function(e){
  if(e.key === "/" && document.activeElement !== q && !/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)){ e.preventDefault(); q.focus(); }
});
if(location.hash){ var el = document.getElementById(location.hash.slice(1)); if(el) el.scrollIntoView({block: "start"}); }

/* mark the topic in view in the side list */
if("IntersectionObserver" in window){
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(!en.isIntersecting) return;
      Array.prototype.forEach.call(toc.querySelectorAll("a"), function(a){ a.classList.toggle("on", a.getAttribute("href") === "#" + en.target.id); });
    });
  }, {rootMargin: "-20% 0px -70% 0px"});
  var watch = function(){ io.disconnect(); Array.prototype.forEach.call(list.querySelectorAll(".topic"), function(el){ io.observe(el); }); };
  watch();
  q.addEventListener("input", watch);
}
